import moment from "moment"

export function useTimeAgo(date: Date | string): string {
  const timeAgo = moment(date).fromNow()
  return timeAgo
}
